import { Injectable } from "@angular/core";
import { UrlConnectionEnum } from "src/app/enums/connection/url-connection.enum";
import { ModelLocatorService } from "../config/model-locator.service";
import { HttpService } from "../http-service/http.service";

@Injectable()
export class ProfileService {

    constructor(private httpService: HttpService,
        private modelLocator: ModelLocatorService) {

    }

    /**
     * Gets all data profile
     * @author Starley Cazorla
     * @returns
     */
    getAllDataProfile() {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(true);

            try {
                this.httpService.get(UrlConnectionEnum.GET_PROFILE, { "cpf": this.modelLocator.dadosLogin.cpf }, config).subscribe(
                    {
                        next: (data) => {
                            if (data['status'] == 200) {
                                resolve(data['result']);
                            }
                        },
                        error: (error) => {
                            reject(error);
                        }
                    }
                );
            } catch (error) {
                reject(error);
            }
        });
    }

    /**
     * Updates password
     * @author Starley Cazorla
     * @param newPwd
     * @returns
     */
    updatePassword(newPwd: string) {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(true);

            let body = {
                cpf: this.modelLocator.dadosLogin.cpf,
                senha: newPwd
            };

            try {
                this.httpService.post(UrlConnectionEnum.UPDATE_PROFILE_PWD, body, config).subscribe(
                    {
                        next: (data) => {
                            resolve(data);
                        },
                        error: (error) => {
                            reject(error);
                        }
                    }
                );
            } catch (error) {
                reject(error);
            }
        });
    }

    /**
     * Updates profile
     * @author Starley Cazorla
     * @param updateData
     * @returns
     */
    updateProfile(updateData: any) {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(true);

            try {
                this.httpService.post(UrlConnectionEnum.UPDATE_PROFILE, updateData, config).subscribe(
                    {
                        next: (data) => {
                            resolve(data);
                        },
                        error: (error) => {
                            reject(error);
                        }
                    }
                );
            } catch (error) {
                reject(error);
            }
        });
    }

    /**
     * Deletes profile
     * @author Starley Cazorla
     * @returns
     */
    deleteProfile(){
        return new Promise((resolve, reject) => {

            const config = this.httpService.setHeaderConfig(true);

            this.httpService.post(UrlConnectionEnum.DELETE_PROFILE, { "cpf": this.modelLocator.dadosLogin.cpf }, config).subscribe(
                {
                    next: (data) => {
                        resolve(data);
                    },
                    error: (error) => {
                        reject(error);
                    }
                }
            )
        })
    }

}
